var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingStep01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5263 11.5861H7.51635C4.68313 11.5861 2.38635 13.8829 2.38635 16.7161V51.2061C2.38635 54.0393 4.68313 56.3361 7.51635 56.3361H61.5263C64.3596 56.3361 66.6564 54.0393 66.6564 51.2061V16.7161C66.6564 13.8829 64.3596 11.5861 61.5263 11.5861Z",
    fill: "url(#paint0_linear_801_3423)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9664 20.5661H10.4764V23.2761H51.9664V20.5661Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2164 26.8761H10.4764V29.5861H41.2164V26.8761Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2164 32.6061H10.4764V35.3161H41.2164V32.6061Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6164 39.4561H10.4764V42.1661H35.6164V39.4561Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.998 65.4961C70.1746 63.8846 76.3073 55.1391 74.6958 45.9625C73.0844 36.7858 64.3389 30.6531 55.1623 32.2646C45.9856 33.876 39.8529 42.6215 41.4644 51.7982C43.0758 60.9748 51.8213 67.1075 60.998 65.4961Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1763 58.1361L51.9763 40.4661C51.9263 39.7661 52.6263 39.2661 53.2763 39.5361L70.5563 46.6461C71.2363 46.9261 71.3463 47.8461 70.7463 48.2761L65.5963 52.0061C65.1763 52.3061 65.0863 52.8961 65.3763 53.3161L69.9763 59.7861C70.2763 60.2061 70.1763 60.7961 69.7563 61.0961L66.9863 63.0661C66.5463 63.3761 65.9363 63.2561 65.6463 62.8061L61.1063 55.7661C60.8263 55.3261 60.2363 55.2061 59.8063 55.4861L54.6263 58.8661C54.0263 59.2561 53.2263 58.8661 53.1763 58.1461V58.1361Z",
    fill: "#C45F44"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_801_3423",
    x1: 2.38635,
    y1: 33.9661,
    x2: 66.6564,
    y2: 33.9661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingStep01);
export default __webpack_public_path__ + "static/media/booking-step-01.8b7bf09f4ace6491827088cfc62ea9c9.svg";
export { ForwardRef as ReactComponent };